import React from "react"

import ListWidgetHeader from "../../common/ListWidgetHeader"
import SearchBar from "../../common/SearchBar"

import InsightAreaListContainer from "./InsightAreaListContainer"

const InsightAreaListWidget = ({
    onFilterSelect,
    canAdd,
    isFetching,
    invalidate,
    pagingRequest,
    nameSearchTerm,
    isEmptySearchValue,
    onSearch,
    onAdd
}) => (
    <div className="widget">
        <ListWidgetHeader
            isFetching={isFetching}
            canAdd={canAdd}
            iconComponent={<span className="icon icon-insights" />}
            listTitle="Insight areas"
            invalidate={invalidate(pagingRequest)}
            onAdd={onAdd}
            onFilterSelect={onFilterSelect(pagingRequest)}
        />
        <div className="quick-filters">
            <SearchBar searchTerm={nameSearchTerm} onSearch={onSearch} />
            <div className="form-check">
                <label className="form-check-label">
                    <input
                        className="form-check-input"
                        name="empty"
                        type="checkbox"
                        checked={isEmptySearchValue}
                        onChange={onSearch}
                    />&nbsp; Only insight areas without mappings
                </label>
            </div>
        </div>
        <InsightAreaListContainer />
    </div>
)

export default InsightAreaListWidget
